import { useMutation, useQueryClient } from '@tanstack/react-query'
import { OtpProviderService } from '@/modules/otp-provider/api/services'
import { OTP_PROVIDER_QUERY_KEYS } from '@/modules/otp-provider/constants'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'

const useMutationDeleteOtpProvider = () => {
	const queryClient = useQueryClient()

	return useMutation<void, Error, string>({
		mutationFn: (id) => OtpProviderService.deleteOtpProvider(id),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: OTP_PROVIDER_QUERY_KEYS.PROVIDERS.ALL,
			})
			toast.success('ลบผู้ให้บริการ OTP สำเร็จ')
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})
}

export default useMutationDeleteOtpProvider
